window.commonDialogList = [
  {
    parentData: {
      selector: 'mkt-wheel[show-type="dialog"]',
      type: 'web_component',
      controlType: 1,
      key: 'open',
    },
    dialogData: {
      // 大转盘弹窗
      selector: 'mkt-drawer',
      type: 3,
      key: 'visible',
    },
    showType: 'all',
    delay: 5000,
  },
  {
    parentData: {
      selector: 'body',
    },
    dialogData: {
      // 小购物车
      selector: '.mk-astro-popup-cart-drawer',
      type: 1,
    },
    showType: 'manual',
  },
  {
    parentData: {
      selector: 'body',
    },
    dialogData: {
      // 登录弹窗
      selector: '.astro-container.login-dialog',
      type: 1,
    },
    showType: 'manual',
  },
  {
    parentData: {
      selector: '#product-installment-rules-modal',
    },
    dialogData: {
      // 分期弹窗
      selector: '#product-installment-rules-modal',
      type: 2,
      key: 'display',
      showValue: 'block',
      closeValue: 'none',
    },
    showType: 'manual',
  },
  {
    parentData: {
      selector: '.mk-search-popup-container',
    },
    dialogData: {
      // 搜索弹窗
      selector: '.mk-search-popup-container',
      type: 4,
      key: 'show',
    },
    showType: 'manual',
  },
  {
    parentData: {
      selector: 'mkt-select-country-popup',
      type: 'web_component',
    },
    dialogData: {
      // 选择站点弹窗
      selector: '.mkt-select-country__popup',
      type: 1,
    },
    showType: 'manual',
  },
  {
    parentData: {
      selector: '#common-modal-wrapper',
    },
    dialogData: {
      // 服务弹窗
      selector: '#common-modal-wrapper',
      type: 2,
      key: 'display',
      showValue: 'block',
      closeValue: 'none',
    },
    showType: 'manual',
  },
  {
    parentData: {
      selector: '#mk-sec-modal_stable',
    },
    dialogData: {
      // Shopify editor弹窗
      selector: '#mk-sec-modal_stable',
      type: 2,
      key: 'display',
      showValue: 'block',
      closeValue: 'none',
    },
    showType: 'manual',
  },
  {
    parentData: {
      selector: '#mk-sec-modal_v2',
    },
    dialogData: {
      // Shopify editor弹窗
      selector: '#mk-sec-modal_v2',
      type: 2,
      key: 'display',
      showValue: 'block',
      closeValue: 'none',
    },
    showType: 'manual',
  },
  {
    parentData: {
      selector: '#product-info-limit-gift-modal',
    },
    dialogData: {
      // 产品限时赠品弹窗
      selector: '#product-info-limit-gift-modal',
      type: 2,
      key: 'display',
      showValue: 'block',
      closeValue: 'none',
    },
    showType: 'manual',
  },
  {
    // 弹窗父层元素是body，但是弹窗是通过属性/css控制展示时，由于body没有监听属性变化，所以需要监听对应弹窗元素
    parentData: {
      selector: '#product-option-compare-modal',
    },
    dialogData: {
      // 产品对比弹窗
      selector: '#product-option-compare-modal',
      type: 2,
      key: 'display',
      showValue: 'block',
      closeValue: 'none',
    },
    showType: 'manual',
  },
  {
    parentData: {
      selector: 'body',
    },
    dialogData: {
      // care 弹窗
      selector: '.care-modal-overlay',
      type: 1,
    },
    showType: 'manual',
  },
  {
    parentData: {
      selector: 'body',
    },
    dialogData: {
      // care 弹窗 通用
      selector: '.mk-manual-dialog-by-body',
      type: 1,
    },
    showType: 'manual',
  },
  {
    parentData: {
      selector: '#mk-sec-scale-img-modal',
    },
    dialogData: {
      // 图片弹窗
      selector: '#mk-sec-scale-img-modal',
      type: 2,
      key: 'display',
      showValue: 'block',
      closeValue: 'none',
    },
    showType: 'manual',
  },
  {
    parentData: {
      selector: 'body',
    },
    dialogData: {
      // lit 弹窗
      selector: 'mkt-modal-root',
      type: 1,
    },
    showType: 'manual',
  },
  {
    parentData: {
      selector: '#MainContent #product-info-benefit-entry-modal',
    },
    dialogData: {
      // 图片弹窗
      selector: '#MainContent #product-info-benefit-entry-modal',
      type: 2,
      key: 'display',
      showValue: 'block',
      closeValue: 'none',
    },
    showType: 'manual',
  },
  {
    // lit 组件弹窗
    parentData: {
      selector: 'mkt-drawer',
    },
    dialogData: {
      selector: 'mkt-drawer',
      type: 3,
      key: 'visible',
    },
    showType: 'manual',
  },
];